import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MenuModule } from 'primeng/menu';

import { AuthenticationUserDropdownCommunityModule } from '@usheru-hff/authentication/user-dropdown-community';
import { LanguageSelectorComponent } from '@usheru-hff/core/language-selector';
import { HffCommonUiUserDropdown } from '@usheru-hff/hff-common/ui-user-dropdown';
import { SearchMovieComponent } from '@usheru-hff/shared/feature-search-movie';
import { SharedFeatureSocialLinksModule } from '@usheru-hff/shared/feature-social-links';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';

import { HeaderComponent } from './header/header.component';
import { NormalizeRoutePipe } from './header/normalize-route.pipe';
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    SearchMovieComponent,
    SharedUtilsImageModule,
    SharedUtilsTranslationModule,
    SharedFeatureSocialLinksModule,
    FontAwesomeModule,
    HffCommonUiUserDropdown,
    MenuModule,
    SharedUtilsModule,
    LanguageSelectorComponent,
    AuthenticationUserDropdownCommunityModule,
    NormalizeRoutePipe
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HffCommonUiHeaderModule {}
